<template>
  <div class="encontros-adicionados-container">
    <h4>Encontros Adicionados</h4>

    <div id="lista-encontros">
      <div
        v-if="!encontros || encontros.length === 0"
        class="nenhum-encontro"
      >
        Nenhum encontro adicionado.
      </div>

      <div
        class="encontro-item transform-container"
        v-for="(encontro, index) in encontros"
        :key="index"
      >
        <div class="informacoes-encontro">
          <h5>{{ encontro.titulo }}</h5>
          <p>{{ encontro.descricao }}</p>
          <p class="data-encontro">
            {{ formatarDataHora(encontro.inicio_periodo) }}
            -
            {{
              encontro.fim_periodo
                ? formatarDataHora(encontro.fim_periodo)
                : "--"
            }}
          </p>
        </div>

        <template v-if="!['FINALIZADO', 'CANCELADO', 'EM_EXECUCAO'].includes(encontro.status)">
          <button
            class="editar-encontro"
            @click="emit('editar', encontro, index)"
            type="button"
          >
            Editar
          </button>

          <button
            class="excluir-encontro"
            @click="emit('remover', index)"
            type="button"
          >
            Excluir
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatarDataHora } from "@/utils/FormatarEntradas";

defineProps({
  encontros: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["editar", "remover"]);
</script>

<style scoped>
.encontros-adicionados-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#lista-encontros {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
  margin-top: 1rem;
  padding: 0px 10px;
}

#lista-encontros::-webkit-scrollbar {
  width: 6px;
}

#lista-encontros::-webkit-scrollbar-track {
  background: var(--cinza-claro);
  border-radius: 10px;
}

#lista-encontros::-webkit-scrollbar-thumb {
  background: var(--roxo-medio);
  border-radius: 10px;
}

#lista-encontros::-webkit-scrollbar-thumb:hover {
  background: var(--roxo-primario);
}

.nenhum-encontro {
  color: var(--cinza-escuro);
  font-style: italic;
  padding: 15px 0;
}

.encontro-item {
  display: flex;
  position: relative;
  align-items: center;
  background-color: var(--roxo-superficie);
  width: 100%;
  border-radius: 25px;
  min-height: 120px;
  margin: 10px 0;
  padding: 25px 15px;
  padding-right: 50px;
}

.informacoes-encontro {
  flex: 1;
  padding-right: 10px;
}

.informacoes-encontro h5 {
  margin: 0 0 8px 0;
  color: var(--roxo-medio);
  font-weight: 600;
  font-size: 1.1rem;
  word-break: break-word;
}

.informacoes-encontro p {
  margin: 0 0 5px 0;
  color: hsla(0, 0%, 0%, 0.502);
  font-size: 0.95rem;
  word-break: break-word;
}

.data-encontro {
  font-size: 0.85rem !important;
  font-weight: 500;
  color: var(--roxo-medio) !important;
  margin-top: 8px !important;
}

.editar-encontro,
.excluir-encontro {
  position: absolute;
  color: var(--branco);
  border: none;
  padding: 8px 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.editar-encontro:hover,
.excluir-encontro:hover {
  opacity: 0.9;
}

.editar-encontro {
  bottom: 0;
  right: 0;
  background-color: var(--roxo-primario);
  border-radius: 20px 0 20px 0;
}

.editar-encontro:hover {
  background-color: var(--roxo-medio);
}

.excluir-encontro {
  top: 0;
  right: 0;
  background-color: var(--vermelho-escuro);
  border-radius: 0 20px 0 20px;
}

.excluir-encontro:hover {
  background-color: var(--vermelho);
}

@media (max-width: 768px) {
  .encontro-item {
    padding: 20px 12px;
    padding-right: 45px;
    min-height: 110px;
  }

  .informacoes-encontro h5 {
    font-size: 1rem;
  }

  .informacoes-encontro p {
    font-size: 0.9rem;
  }

  .editar-encontro,
  .excluir-encontro {
    padding: 6px 15px;
    font-size: 0.85rem;
  }

  #lista-encontros {
    max-height: 400px;
  }
}

@media (max-width: 480px) {
  .encontro-item {
    padding: 15px 10px;
    padding-right: 40px;
    min-height: 100px;
    border-radius: 20px;
  }

  .informacoes-encontro h5 {
    font-size: 0.95rem;
  }

  .informacoes-encontro p {
    font-size: 0.85rem;
  }

  .data-encontro {
    font-size: 0.8rem !important;
  }

  .editar-encontro,
  .excluir-encontro {
    padding: 5px 12px;
    font-size: 0.8rem;
  }

  .editar-encontro {
    border-radius: 15px 0 15px 0;
  }

  .excluir-encontro {
    border-radius: 0 15px 0 15px;
  }

  #lista-encontros {
    max-height: 350px;
  }
}

@media (max-width: 320px) {
  .encontro-item {
    padding: 12px 8px;
    padding-right: 35px;
  }

  .informacoes-encontro h5 {
    font-size: 0.9rem;
  }

  .informacoes-encontro p {
    font-size: 0.8rem;
  }

  .editar-encontro,
  .excluir-encontro {
    padding: 4px 10px;
    font-size: 0.75rem;
  }
}

@media (max-height: 600px) {
  #lista-encontros {
    max-height: 300px;
  }
}
</style>
